// IQ Test — assessment-level scoring configuration. Product-confirmed
// facts (not live API fields): question counts and the official 5-tier
// percentage-band table, applied independently to both the overall and
// each individual section percentage.

export const TOTAL_QUESTIONS = 60;
export const QUESTIONS_PER_DOMAIN = 15; // uniform across all 4 sections

// Inclusive integer percentage bounds (0-100). `bandKey` matches the real
// backend ALL_CONTENT band vocabulary — display labels always come from
// ALL_CONTENT, never hardcoded here.
export const OFFICIAL_PERFORMANCE_BANDS = [
  { bandKey: "below_average", min: 0, max: 47 },
  { bandKey: "slightly_below_average", min: 48, max: 60 },
  { bandKey: "average", min: 61, max: 73 },
  { bandKey: "slightly_above_average", min: 74, max: 86 },
  { bandKey: "above_average", min: 87, max: 100 },
];
